/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Settings_BackInputs */

const cs_nav_settings_back = /** @type {(inputs: Nav_Settings_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpět do aplikace`)
};

const en_nav_settings_back = /** @type {(inputs: Nav_Settings_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to app`)
};

/**
* | output |
* | --- |
* | "Back to app" |
*
* @param {Nav_Settings_BackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_settings_back = /** @type {((inputs?: Nav_Settings_BackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Settings_BackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_settings_back(inputs)
	return cs_nav_settings_back(inputs)
});